
import { useState, useEffect } from "react";
import { ApparelProduct } from "@/types";

export interface FilterOptions {
  searchTerm: string;
  selectedCategory: string;
  sortBy: string;
  statusTab: string;
}

export const useProductFiltering = (products: ApparelProduct[]) => {
  const [filteredProducts, setFilteredProducts] = useState<ApparelProduct[]>(products);
  const [filters, setFilters] = useState<FilterOptions>({
    searchTerm: "",
    selectedCategory: "all",
    sortBy: "name",
    statusTab: "all"
  });

  useEffect(() => {
    let result = [...products];

    // Filter by search term
    if (filters.searchTerm) {
      const term = filters.searchTerm.toLowerCase();
      result = result.filter(
        (product) =>
          product.name.toLowerCase().includes(term) ||
          product.description?.toLowerCase().includes(term) ||
          product.category.toLowerCase().includes(term)
      );
    }

    // Filter by category
    if (filters.selectedCategory && filters.selectedCategory !== "all") {
      result = result.filter((product) => product.category === filters.selectedCategory);
    }

    // Filter by status
    if (filters.statusTab === "active") {
      result = result.filter((product) => product.status === "active");
    } else if (filters.statusTab === "inactive") {
      result = result.filter((product) => product.status === "inactive");
    } else if (filters.statusTab === "archived") {
      result = result.filter((product) => product.status === "archived");
    }

    // Sort the results
    if (filters.sortBy === "name") {
      result.sort((a, b) => a.name.localeCompare(b.name));
    } else if (filters.sortBy === "price-asc") {
      result.sort((a, b) => a.price_cents - b.price_cents);
    } else if (filters.sortBy === "price-desc") {
      result.sort((a, b) => b.price_cents - a.price_cents);
    } else if (filters.sortBy === "newest") {
      result.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    }

    setFilteredProducts(result);
  }, [products, filters]);

  const updateFilters = (newFilters: Partial<FilterOptions>) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  return {
    filteredProducts,
    filters,
    updateFilters
  };
};
